export const getFullPath = (url: string) => {
  try {
    return new URL(url, window.location.origin).href;
  } catch (_) {
    return undefined;
  }
};
